<template>
  <div class="works">
  <section class="banner_area">
    <div class="banner_inner d-flex align-items-center">
      <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
      <div class="container">
         <div class="banner_content text-left">
            <div class="page_link">
               <router-link to="/"><a>Home</a></router-link>
               <router-link to="/works"><a>Works</a></router-link>
            </div>
            <h2 style="color: black;">Our Works</h2>
            <br><br><br>
            <h3  style="color: black;">Ongoing Projects</h3>
            <ul>
              <li  style="color: black;">IOT based automatic Bell-System</li>
            </ul>

            <h3  style="color: black;">Completed Projects</h3>
            <ul>
              <li  style="color: black;">University Surgical Unit (Teaching Hospital Batticaloa)</li>
              <li  style="color: black;">
                Zonal Education Office Web Application (Batticaloa West)
              </li>
              <li  style="color: black;">  
                Quiz Web Application (Science Navigators Organization)  
              </li>
            </ul>        
         </div>
      </div>
    </div>
   </section>
 
  <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer
  }
};
</script>
